import React from "react";

import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import ArrowForward from "@mui/icons-material/ArrowForward";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSnackbar } from "notistack";

import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";

import SvgIconStyle from "../../../components/SvgIconStyle";
import { Tooltip } from "@mui/material";
import CartItem from "../CartItem";

import {
  clearCart,
  setDonationTab,
  updateDonation,
  clearDonationCart,
  getDonation,
  addProduct,
  setRecolhaDate,
  setStartDate,
  setEndDate,
  setSelectProductError,
  setAnimalEndDate,
  addCollectorInviteForDonation,
} from "../slice";

import {
  drawerStyles,
  mainBoxStyles,
  avataStyles,
  svgIconStyle,
  buttonBoxStyles,
  lockButtonStyles,
  lockIconStyles,
} from "./styles";
import {
  getMyActiveDonation,
  setMyActiveDonationsLimit,
  setMyActiveDonationsOffset,
  setMyActiveDonationsPage,
} from "../../DashBoardView/slice";
import {
  ComponentType,
  DonationStatus,
  EntityType,
  units,
} from "../../../common/enum";
import {
  setConfirmationDialog,
  setSnackbarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
} from "../../AdminView/adminSlice";

export default function Cart({ t, open, setOpen }) {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const {
    donationCart: {
      products: items,
      donationTab,
      donationId,
      updateDonationDetail,
      collectorInviteNames,
    },
    auth: {
      profile: { entity },
    },
  } = useSelector((state) => state);

  const onClearCart = (e, itemID) => {
    e.preventDefault();
    dispatch(setConfirmationDialog(true));
  };

  const previousTabHandler = React.useCallback(() => {
    dispatch(setDonationTab("product"));
  }, [dispatch]);

  const addCollectorInvite = () => {
    const payload = {
      id: 0,
      donationId: donationId,
      collectorEntityId: collectorInviteNames.map((n) => n?.entity?.entityId),
      sentBy: entity?.entityId,
      status: "INVITED",
    };

    dispatch(addCollectorInviteForDonation(payload));
  };

  const onContinue = async () => {
    switch (donationTab.toString()) {
      case "product":
        if (items.length > 0) {
          dispatch(setSelectProductError(false));
          dispatch(setDonationTab("collection"));
        } else {
          dispatch(setSelectProductError(true));
        }
        break;
      case "collection":
        if (items.length > 0) {
          if(updateDonationDetail["isAnimal"] === true){
            const availableToDate = new Date(updateDonationDetail["availableToDate"]);
            const consumedByDate = new Date(updateDonationDetail["consumedByDate"]);
        
            const timeDifference = consumedByDate - availableToDate;
            const hoursDifference = timeDifference / (1000 * 60 * 60);
            const hasPassed24Hours = hoursDifference >= 1;
            
            if(hasPassed24Hours == true){
              if (Object.keys(updateDonationDetail).length > 0) {
                if (updateDonationDetail["availableFromDate"] === undefined || new Date (updateDonationDetail["availableFromDate"]) < new Date()) {
                  dispatch(setStartDate(true));
                } else if (updateDonationDetail["availableToDate"] === undefined ||  new Date (updateDonationDetail["availableToDate"]) < new Date() ) {
                  dispatch(setEndDate(true));
                } else if (updateDonationDetail["addressId"] === undefined) {
                  dispatch(setSelectProductError(true));
                } else if (
                  updateDonationDetail["isAnimal"] !== undefined &&
                  updateDonationDetail["isAnimal"] === true &&
                  updateDonationDetail["consumedByDate"] === undefined
                ) {
                  dispatch(setAnimalEndDate(true));
                } else {
                  const payload = {
                    ...updateDonationDetail,
                  };
                  payload["isAnimal"] =
                    updateDonationDetail["isAnimal"] === undefined
                      ? false
                      : updateDonationDetail["isAnimal"];
                  dispatch(setSelectProductError(false));
                  await addCollectorInvite();
                  await dispatch(updateDonation(payload))
                    .unwrap()
                    .then(() => {
                      navigate("/dashboard");
                      dispatch(clearDonationCart());
                      const data = {
                        limit: 10,
                        offset: 0,
                        entityType:
                          entity?.entityType === EntityType.donorDistributor
                            ? EntityType.donor
                            : entity?.entityType,
                        // status: DonationStatus.new,
                      };
                      if (entity.entityType === EntityType.donor) {
                        data["entityId"] = entity.entityId;
                      }
                      dispatch(getMyActiveDonation(data));
                      dispatch(setMyActiveDonationsLimit(10));
                      dispatch(setMyActiveDonationsOffset(0));
                      dispatch(setMyActiveDonationsPage(1));
                      enqueueSnackbar({
                        variant: "success",
                        message: t("donationCreatedSuccessfully"),
                      });
                      dispatch(setDonationTab("product"));
                    })
                    .catch((err) => {
                      // alert("Failed to Update donation Info");
                      enqueueSnackbar({
                        message: t("failedToUpdateDonation"),
    
                        variant: "error",
                      });
                    });
                }
              } else {
                enqueueSnackbar({
                  message: t("selectAddress"),
    
                  variant: "error",
                });
                dispatch(setRecolhaDate(true));
              }
            }else{
              enqueueSnackbar({
                message: "Data inválida",
                variant: "error",
              });
            }
          }else{
            if (Object.keys(updateDonationDetail).length > 0) {
              if (updateDonationDetail["availableFromDate"] === undefined || new Date (updateDonationDetail["availableFromDate"]) < new Date()) {
                dispatch(setStartDate(true));
              } else if (updateDonationDetail["availableToDate"] === undefined ||  new Date (updateDonationDetail["availableToDate"]) < new Date() ) {
                dispatch(setEndDate(true));
              } else if (updateDonationDetail["addressId"] === undefined) {
                dispatch(setSelectProductError(true));
              } else if (
                updateDonationDetail["isAnimal"] !== undefined &&
                updateDonationDetail["isAnimal"] === true &&
                updateDonationDetail["consumedByDate"] === undefined
              ) {
                dispatch(setAnimalEndDate(true));
              } else {
                const payload = {
                  ...updateDonationDetail,
                };
                payload["isAnimal"] =
                  updateDonationDetail["isAnimal"] === undefined
                    ? false
                    : updateDonationDetail["isAnimal"];
                dispatch(setSelectProductError(false));
                await addCollectorInvite();
                await dispatch(updateDonation(payload))
                  .unwrap()
                  .then(() => {
                    navigate("/dashboard");
                    dispatch(clearDonationCart());
                    const data = {
                      limit: 10,
                      offset: 0,
                      entityType:
                        entity?.entityType === EntityType.donorDistributor
                          ? EntityType.donor
                          : entity?.entityType,
                      // status: DonationStatus.new,
                    };
                    if (entity.entityType === EntityType.donor) {
                      data["entityId"] = entity.entityId;
                    }
                    dispatch(getMyActiveDonation(data));
                    dispatch(setMyActiveDonationsLimit(10));
                    dispatch(setMyActiveDonationsOffset(0));
                    dispatch(setMyActiveDonationsPage(1));
                    enqueueSnackbar({
                      variant: "success",
                      message: t("donationCreatedSuccessfully"),
                    });
                    dispatch(setDonationTab("product"));
                  })
                  .catch((err) => {
                    // alert("Failed to Update donation Info");
                    enqueueSnackbar({
                      message: t("failedToUpdateDonation"),
  
                      variant: "error",
                    });
                  });
              }
            } else {
              enqueueSnackbar({
                message: t("selectAddress"),
  
                variant: "error",
              });
              dispatch(setRecolhaDate(true));
            }
          }
       
         
        } else {
          dispatch(setSelectProductError(true));
          dispatch(setDonationTab("product"));
        }
        break;
    }
  };
  const onClose = React.useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  return (
    <Drawer
      variant={mobile ? "temporary" : "permanent"}
      anchor="right"
      sx={drawerStyles}
      open={mobile ? open : true}
      onClose={onClose}
    >
      <Box sx={{ display: "flex" , flexDirection: "column" }}>
        {items.length > 0 && (
          <>
          <Box sx={{ display: "flex" , flexDirection: "row" }}>
            <Avatar sx={avataStyles}>
              <SvgIconStyle src="/static/dashboard/box.svg" sx={svgIconStyle} />
            </Avatar>
            <Box sx={{ paddingLeft: "10px", mb: 3 }}>
              <Typography
                sx={{ marginTop: "10px" }}
                fontWeight="bold"
                fontSize={"large"}
              >
                {t("Articles")}
              </Typography>
              <Typography>{t("listOfItem")}</Typography>
            </Box>
            <br></br>
          </Box> 
         
          </>
          
          
        )}
        {mobile && (
          <Button sx={{ minWidth: "0px" }} onClick={onClose}>
            <CloseRoundedIcon />
          </Button>
        )}
      </Box>
      {items.length > 0 ? (
        <Box
          sx={{
            height: "78vh",
            overflow: "hidden",
            overflowY: "scroll",
            scrollbarColor: "#37b34a #e4fbe7",
            scrollBehavior: "smooth",
            paddingBottom: "30%",
            pr: 2,
            "&::-webkit-scrollbar": {
              height: 1,
              width: 12,
              background: "#e4fbe7",
            },

            "&::-webkit-scrollbar-thumb": {
              background: "#37b347",
              "-webkit-border-radius": "1ex",
              // "-webkit-box-shadow": "0px 1px 2px rgba(0, 0, 0, 0.75)",
            },

            "&::-webkit-scrollbar-corner": {
              background: "#e4fbe7",
            },
          }}
        >
          {" "}
          {items.map((item) => {
            return (
              <CartItem
                item={item}
                t={t}
                key={item.productId}
                component={ComponentType.CART_PRODUCT}
              />
            );
          })}
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "50%",
          }}
        >
          <Avatar sx={avataStyles}>
            <SvgIconStyle src="/static/dashboard/box.svg" sx={svgIconStyle} />
          </Avatar>
          <Box sx={{ paddingLeft: "10px" }}>
            <Typography sx={{ marginTop: "10px" }}>
              {t("emptyCart")} :(
            </Typography>
          </Box>
        </Box>
      )}
      <Box sx={buttonBoxStyles}>
        
        <Box style={{ display: "flex", width: "100%", alignItems: "center" , justifyContent: "space-between"}}>
           <Box sx={{ display: "flex", gap: 5}}>
           {items.length > 0 && donationTab.toString() === "product" &&(
       
          <Tooltip
              title={"Limpar campos"}
              arrow
              
            >
              <Button style={{backgroundColor: "#EEEEEE", padding: "9px 16px"}} onClick={(e) => onClearCart(e)}>
                <SvgIconStyle src="/static/dashboard/lock.svg" sx={lockIconStyles} />
                <span style={{ color: "black", fontSize: "14px" }}>Esvaziar lista</span>
              </Button>
            </Tooltip>
        )}
          {donationTab.toString() === "collection" && (
            <Button
              onClick={previousTabHandler}
              sx={{
                borderRadius:"4px"
              }}
              size="large"
              variant="contained"
              color="grey"
              startIcon={<ArrowBackIcon fontSize="16px" />}
            >
              <Typography variant="bold">{t("toGoBack")}</Typography>
            </Button>
          )}
          </Box>

          <Button
            size="large"
            variant="contained"
            onClick={() => onContinue()}
            endIcon={
              donationTab.toString() === "collection" ? (
                <CheckCircleOutlineOutlinedIcon fontSize="16px" />
              ) : (
                <ArrowForward fontSize="16px" />
              )
            }
            sx={{borderRadius:"4px"}}
          >
            <Typography variant="bold">
              {donationTab.toString() === "collection"
                ? "Finalizar"
                : "Continuar"}
            </Typography>
          </Button>
        </Box>
      </Box>
      
    </Drawer>
  );
}
